import React from 'react';
import styled from 'astroturf/react';
import Modal from 'js/components/modals/Modal';
import $image_url from 'js/utils/image_url';
import routes from 'sitewide-js/core_pre_webpack/routes';
import fetchWithCsrf from 'js/utils/fetch_with_csrf';
import { LocaleCode } from 'js/i18next/i18n.d';
import _StyledModal from "LanguageSwitcherModal-StyledModal.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/LanguageSwitcherModal.tsx?styleId=StyledModal";
import _CloseButton from "LanguageSwitcherModal-CloseButton.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/LanguageSwitcherModal.tsx?styleId=CloseButton";
import _Heading from "LanguageSwitcherModal-Heading.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/LanguageSwitcherModal.tsx?styleId=Heading";
import _BetaText from "LanguageSwitcherModal-BetaText.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/LanguageSwitcherModal.tsx?styleId=BetaText";
import _ButtonContainer from "LanguageSwitcherModal-ButtonContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/LanguageSwitcherModal.tsx?styleId=ButtonContainer";
import _LanguageButton from "LanguageSwitcherModal-LanguageButton.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/LanguageSwitcherModal.tsx?styleId=LanguageButton";
import _LanguageText from "LanguageSwitcherModal-LanguageText.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/LanguageSwitcherModal.tsx?styleId=LanguageText";
import _LanguageIcon from "LanguageSwitcherModal-LanguageIcon.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/LanguageSwitcherModal.tsx?styleId=LanguageIcon";
import _Disclaimer from "LanguageSwitcherModal-Disclaimer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/LanguageSwitcherModal.tsx?styleId=Disclaimer";


const PHONE_SIZE = 560;

const switchLanguage = (language: LocaleCode) => {
  fetchWithCsrf(
    routes.api_v0_user_display_locales_path({
      subdomain_param: 'api',
      preferred_locale: language,
      user_id: window.Aedu.User.current.id,
    }),
    { method: 'POST' },
  ).then(() => window.location.reload());
};
interface Props {
  onClose: () => void;
}

const LanguageSwitcherModal: React.FC<Props> = ({ onClose }) => (
  <StyledModal
    onClose={onClose}
    showCloseButton={false}
    ariaLabelledby="Language Switcher"
  >
    <Heading>
      Select your language <BetaText>BETA</BetaText>
    </Heading>
    <ButtonContainer>
      <LanguageButton
        aria-label="Language Button English"
        onClick={() => switchLanguage('en')}
      >
        <LanguageIcon
          src={$image_url(`localization/flags/en.svg`)}
          aria-label="Language Icon English"
        ></LanguageIcon>
        <LanguageText aria-label="Language Text English">English</LanguageText>
      </LanguageButton>
      <LanguageButton
        aria-label="Language Icon Español"
        onClick={() => switchLanguage('es')}
      >
        <LanguageIcon
          src={$image_url(`localization/flags/es.svg`)}
          aria-label="Language Icon Español"
        ></LanguageIcon>
        <LanguageText aria-label="Language Text Español">Español</LanguageText>
      </LanguageButton>
    </ButtonContainer>
    <Disclaimer>
      Note that not all parts of the site are available in all languages yet.
    </Disclaimer>
    <CloseButton aria-label="Close" onClick={() => setTimeout(onClose, 0)}>
      ×
    </CloseButton>
  </StyledModal>
);

const StyledModal = /*#__PURE__*/styled(Modal, null, {
  displayName: "StyledModal",
  styles: _StyledModal
});

const CloseButton = /*#__PURE__*/styled("button", null, {
  displayName: "CloseButton",
  styles: _CloseButton
});

const Heading = /*#__PURE__*/styled("h2", null, {
  displayName: "Heading",
  styles: _Heading
});

const BetaText = /*#__PURE__*/styled("span", null, {
  displayName: "BetaText",
  styles: _BetaText
});

const ButtonContainer = /*#__PURE__*/styled("div", null, {
  displayName: "ButtonContainer",
  styles: _ButtonContainer
});

const LanguageButton = /*#__PURE__*/styled("button", null, {
  displayName: "LanguageButton",
  styles: _LanguageButton
});

const LanguageText = /*#__PURE__*/styled("span", null, {
  displayName: "LanguageText",
  styles: _LanguageText
});

const LanguageIcon = /*#__PURE__*/styled("img", null, {
  displayName: "LanguageIcon",
  styles: _LanguageIcon
});

const Disclaimer = /*#__PURE__*/styled("p", null, {
  displayName: "Disclaimer",
  styles: _Disclaimer
});

export default LanguageSwitcherModal;
